export const LanguageType = {
	English: 'en',
	Hebrew: 'he',
	Spanish: 'es',
	Default: 'default', // take the language from the company settings
} as const;
export type LanguageType = (typeof LanguageType)[keyof typeof LanguageType];

export function isLanguageType(value: unknown): value is LanguageType {
	return Object.values(LanguageType).includes(value as LanguageType);
}

export function isDefaultLanguage(value: unknown): boolean {
	return value === LanguageType.Default;
}

export type SupportedLanguageType = Exclude<LanguageType, 'default'>;

export function isSupportedLanguage(value: unknown): value is SupportedLanguageType {
	return isLanguageType(value) && !isDefaultLanguage(value);
}
